/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsHoopListItem,
    AssetsMelcoModelsHoopListItemFromJSON,
    AssetsMelcoModelsHoopListItemFromJSONTyped,
    AssetsMelcoModelsHoopListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsGenericList1MelcoModelsHoopListItem
 */
export interface AssetsMelcoModelsGenericList1MelcoModelsHoopListItem {
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopListItem>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsHoopListItem
     */
    list: Array<AssetsMelcoModelsHoopListItem>;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsHoopListItem
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsHoopListItem
     */
    total: number;
}

export function AssetsMelcoModelsGenericList1MelcoModelsHoopListItemFromJSON(json: any): AssetsMelcoModelsGenericList1MelcoModelsHoopListItem {
    return AssetsMelcoModelsGenericList1MelcoModelsHoopListItemFromJSONTyped(json, false);
}

export function AssetsMelcoModelsGenericList1MelcoModelsHoopListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsGenericList1MelcoModelsHoopListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AssetsMelcoModelsHoopListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function AssetsMelcoModelsGenericList1MelcoModelsHoopListItemToJSON(value?: AssetsMelcoModelsGenericList1MelcoModelsHoopListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AssetsMelcoModelsHoopListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


